"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    mapUnavailable: {
        en: "map instances is not available yet",
        es: "El mapa no esta disponible!",
    },
    deletingPlaceError: {
        en: "unable to delete place",
        es: "No se puede eliminar la geocerca.",
    },
    searchPlace: {
        en: "Search Geofence",
        es: "Buscar Geocerca",
    },
    addGeofence: {
        en: "Add Geofence",
        es: "Agregar Geocerca",
    },
    editPlace: {
        en: "Edit Geofence",
        es: "Editar Geocerca",
    },
    deletePlace: {
        en: "Delete Geofence",
        es: "Eliminar Geocerca",
    },
    confirmDeletePlace: {
        en: "Do you want to delete this geofence?",
        es: "Deseas eliminar está geocerca?",
    },
    drawAPlace: {
        en: "You need to create a geofence!",
        es: "Necesitas crear una geocerca!",
    },
    enter: {
        en: "Enter",
        es: "Entrada",
    },
    leave: {
        en: "Exit",
        es: "Salida",
    },
    enterAndLeave: {
        en: "Enter & Exit",
        es: "Entrada & Salida",
    },
    remainInArea: {
        en: "Parked in Geofence",
        es: "Estacionado en Zona",
    },
    speedControl: {
        en: "Speed Control",
        es: "Control de Velocidad",
    },
    placeNameRequiredMessage: {
        en: "The geofence name is required!",
        es: "El nombre de la geocerca es requerido!",
    },
    placeTolerance: {
        en: "Width",
        es: "Separación",
    },
    addBehavior: {
        en: "Add Behavior",
        es: "Nuevo Comportamiento",
    },
    behavior: {
        en: "Behavior",
        es: "Comportamiento",
    },
    savePlaceSuccess: {
        en: "The geofence was saved successfully.",
        es: "La geocerca se guardo exitosamente.",
    },
    convertToPlace: {
        en: "Convert to geofence",
        es: "Convertir en geocerca",
    },
    displacementAlertSuccess: {
        en: "Displacement Alert created successfully.",
        es: "La Alerta de Desplazamiento se creo con exito.",
    },
    displacementAlertFailed: {
        en: "Displacement Alert already exist for this unit.",
        es: "Alerta de Desplazamiento ya existe para esta unidad.",
    },
    addGeofenceGroup: {
        en: "Group Geofence",
        es: "Agrupar Geocercas",
    },
    addGeofenceGroupSuccess: {
        en: "The geofence group was saved successfully.",
        es: "Se agruparon las geocercas exitosamente.",
    },
    editGeofenceGroup: {
        en: "Edit Geofence Group",
        es: "Editar Grupo de Geocercas",
    },
    deletePlaceGrouping: {
        en: "Delete Geofence Group",
        es: "Borrar Agrupamiento de Geocercas",
    },
    confirmDeletePlaceGrouping: {
        en: "Do you want to delete this geofence group?",
        es: "Deseas eliminar este agrupamiento de geocercas?",
    },
    sharedGroupLabel: {
        en: 'Shared Group',
        es: 'Grupo Compartido'
    },
    ownGroup: {
        en: 'Own Group',
        es: 'Grupo personal'
    }
};
exports.default = translations;
